<template>
  <ValidationProvider
    id="file-upload-format"
    v-slot="{ classes, errors }"
    :name="validationName"
    :rules="`${required ? 'required' : ''}`"
  >
    <div
      class="control"
      :class="required ? classes : ''"
    >
      <Multiselect
        v-model="selectedFormat"
        :loading="loading"
        :options="groupedDataFormats"
        track-by="codename"
        label="display_name"
        group-values="formats"
        group-label="type"
        :group-select="false"
        select-label=""
        selected-label=""
        deselect-label=""
        :searchable="false"
        :placeholder="$t('resource.format.placeholder')"
      />
      <span class="form-errors">{{ errors[0] }}</span>
    </div>
  </ValidationProvider>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import Multiselect from 'vue-multiselect';
import { ValidationProvider, extend, configure } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';

extend('required', {
  ...required,
  message: 'Ce champ est requis'
});
configure({
  classes: {
    valid: 'is-valid',
    invalid: 'is-invalid'
  }
});

export default {
  name: 'ValidatedFileFormatSelector',

  components: {
    Multiselect,
    ValidationProvider
  },

  props: {
    required: {
      type: Boolean,
      default: false
    },
    validationName: {
      type: String,
      default: ''
    },
    initValue: {
      type: Object,
      default: () => {
        return null;
      }
    },
    formatFilter: {
      type: Object,
      default: () => {
        return null;
      }
    }
  },

  data() {
    return {
      loading: false,
      selectedFormat: null
    };
  },

  computed: {
    ...mapState('resources', [
      'resourceDataFormats',
    ]),
    allowedFormats() {
      if (this.formatFilter && this.formatFilter.id) {
        const format = this.resourceDataFormats.find(el => el.id === this.formatFilter.id);
        const type = this.resourceDataFormats.find(el => el.codename === format.codename).type;
        if (type && type.id) {
          return this.resourceDataFormats.filter(el => el.type.id === type.id);
        }
      }
      return null;
    },
    groupedDataFormats() {
      if (this.resourceDataFormats && this.resourceDataFormats.length) {
        const formatsList = this.allowedFormats ? this.allowedFormats : this.resourceDataFormats;
        const formatsGroupeByType = formatsList.reduce(
          (acc, value) => {
            const foundTypeIndex = acc.findIndex(el => el.type === value.type.label);
            if (foundTypeIndex === -1) {
              acc.push({
                type: value.type.label,
                formats: [value]
              });
            } else {
              acc[foundTypeIndex].formats.push(value);
            }
            return acc;
          },
          []
        );
        return formatsGroupeByType;
      } else {
        return [];
      }
    }
  },

  watch: {
    selectedFormat: {
      deep: true,
      handler(newValue) {
        this.$emit('select', newValue);
      }
    }
  },

  async created() {
    if (this.resourceDataFormats.length === 0) {
      this.loading = true;
      await this.GET_RESOURCE_DATA_FORMATS();
      this.loading = false;
    }
  },

  mounted() {
    if (this.initValue) {
      this.selectedFormat = this.initValue;
    }
  },

  methods: {
    ...mapActions('resources', [
      'GET_RESOURCE_DATA_FORMATS'
    ]),
  }
};
</script>
